/// <reference path="../types/index.d.ts" />

import '../client_forms/mculinary1/style.css';
import FormStructure from './mculinary1/form_structure';

export default FormStructure;